'use strict';
var app = require('angular').module('dashboard');
app.factory('gridConfiguration', ['$state', '$serverData', '$compile', '$translate', 'siteConfig', 'toast', require('../gridFactory')]);
app.controller('dashboardStatisticsCtrl', ['Member','$scope','myTenant','Tenant', 'gridConfiguration','$translate', require('./dashboardStatisticsCtrl')]);
app.config(['$stateProvider', require('./dashboardStatisticsConfig')]);
